import Badge from '@mui/material/Badge';
import MuiIconButton from '@mui/material/IconButton';

import { darken, styled } from '@mui/material/styles';

export const PageRoot = styled(Badge, { label: 'PageRoot' })(({ theme }) => ({
  position: 'relative',
  margin: theme.spacing(2.5, 0),

  '& + &': {
    marginLeft: `${theme.spacing(7)} /* @noflip */`,
  },

  '&.page-is-dragging': {
    zIndex: 10004,
    boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.1)',

    '& > div': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },

  '& .MuiBadge-badge': {
    right: '50%',
    fontSize: 14,
    height: 28,
    minWidth: 28,
    borderRadius: 14,
    backgroundColor: theme.palette.grey[500],
    padding: theme.spacing(0, 1.25),
  },

  '&:hover .preview-eye-icon': {
    opacity: 1,
  },
}));

export const PreviewButton = styled(MuiIconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.common.white}`,
  width: 40,
  height: 40,
  padding: theme.spacing(1),
  borderRadius: 50,
  margin: 'auto',
  zIndex: 1,
  opacity: 0,

  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.1),
    boxShadow: theme.shadows[5],
  },
}));
